import jwtDecode from 'jwt-decode'

import { getAuthToken } from 'utils/auth'

export default function createInitialState () {
  return {
    auth: {
      userId: getAuthToken() && jwtDecode(getAuthToken()).user_id
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/store/initialState.js